<p>info-company-modal works!</p>
